import Customers from './Customers'

export default Customers



// WEBPACK FOOTER //
// ./src/components/Customers/index.js